/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'social-logo-linkedin': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" fill-rule="evenodd" d="M16.381 2.5H3.62A1.113 1.113 0 002.5 3.581v12.794a1.106 1.106 0 001.119 1.081H16.38a1.106 1.106 0 001.119-1.081V3.581A1.113 1.113 0 0016.381 2.5zM6.944 15.256h-2.2V8.125h2.2v7.131zM5.869 7.131c-.703 0-1.277-.56-1.294-1.262a1.25 1.25 0 011.294-1.294 1.294 1.294 0 010 2.581v-.025zm9.431 8.082h-2.175v-3.488c0-.831 0-1.912-1.162-1.912-1.163 0-1.338.912-1.338 1.83v3.532H8.4v-7.05h2.075v.938h.044A2.325 2.325 0 0112.637 7.9c2.244 0 2.663 1.5 2.663 3.406v3.907z"/>'
  }
})
